/**
 * The "?" in the top bar: a shortcut to `/app/tours`.
 *
 * Not a popover of its own — the nav rail already has a "Tour guidati" destination pointing at
 * the same page (see `shell/nav.ts`), and a second list here would be the same three cards kept
 * two ways, one of which drifts the day a fourth one is added.
 */

import type { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

import { Icon } from '../../components/ui/Icon'
import { useT } from '../../lib/i18n'

export const HelpMenu = (): ReactElement => {
  const t = useT()
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => {
        void navigate('/app/tours')
      }}
      aria-label={t('common.nav.tours')}
      className="ring-focus flex h-9 w-9 items-center justify-center rounded-sm text-chrome-mute transition-colors hover:bg-chrome-800 hover:text-chrome-ink"
    >
      <Icon name="info" size={18} />
    </button>
  )
}
